import React from "react";
import styled from "styled-components";
import LogoIcon from "../../assets/Tymeplus HR 1.png";
import { ReactComponent as ProfileImg } from "../../assets/Icons/profile-icon.svg";
import { Button } from "antd";
import LogoutIcon from "@mui/icons-material/Logout";
import bdoLogo from "../../assets/InsytLogo.svg"
import { FormatAlignJustify } from "@mui/icons-material";
const HeaderMenuWrap = styled.div`
  .header-container {
    // width: 100%;
    // position: absolute;
    height: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 16px 16px 16px;
    background: rgb(255, 255, 255);
    border-bottom: 1px solid rgb(240, 240, 240);
    // margin-bottom: 12px;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    img {
      width: 150px;
      cursor: pointer;
    }
  }
  .profile-icon {
    cursor: pointer;
  }
  .header_logo_title {
    width: 250px;
    cursor: pointer;
    margin-right: 200px;
   box-shadow:8px 8px 10px rgba(0, 0, 0, 0.2);
  }
      .logout-icon {
    font-size: 35px; /* Reduce the size of the icon */
    margin-right: 50px;
    cursor: pointer;
 
  }
`;
const HeaderBox = () => {
  const imgStyle = { height: "35px",justifyContent: "center",alignItems: "center",marginLeft:"450px"};
  return (
    <>
      <HeaderMenuWrap className="bg-danger">
        <div className="header-container">
          <div className="logout-icon">
          <img
                        style={imgStyle}
                        src={ bdoLogo }
                        alt="Tymeplus"
                      /></div>
                      <div>
                      {/* <Button className="apply-leave-button" style={{BackgroundColor:"#C2FAE5",diplay:"flex",justifyContent:"space-between"}}>Apply for Leave</Button> */}
            <LogoutIcon style={{ color: "black",fontSize:"15px",diplay:"flex",gap:"2",justifyContent:"space-between" }} />
          </div>
        
       
        {/* Apply for Leave Button */}
        
        
       </div>
      </HeaderMenuWrap>
      </>
  );
};

export default HeaderBox;
